module.exports = __webpack_public_path__ + "img/1f383.5362694.svg";